var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"time",style:(_vm.style)},[_c('div',{staticClass:"time__inner"},[_c('span',{staticClass:"time__hours"},[_vm._v(_vm._s(_vm.hours))]),_c('span',{staticClass:"time__separator"},[_vm._v(":")]),_c('span',{staticClass:"time__minutes"},[_vm._v(_vm._s(_vm.minutes))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }